import { Component, OnInit, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { DirtyComponent } from 'src/app/core/components/errors/dirty-check.component';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { basicSnackBarConfig } from '../../../utils/default-configs/configuration';
import { SnackBarService } from '../../../shared/snack-bar/services/snack-bar.service';
import {
  customMappingConfig,
  addressItemToRemoveInShipper,
  exportCustomerInvoiceItemsToRemoveInShipmentMapping,
  customMappingObjectConfig,
} from './config/mapping-config';
import { AddressService } from '../../address/service/address/address.service';

@Component({
  selector: 'app-custom-mapping',
  templateUrl: './custom-mapping.component.html',
  styleUrls: ['./custom-mapping.component.scss'],
})
export class CustomMappingComponent implements OnInit, DirtyComponent, AfterViewInit {
  userExportedInvoice: boolean = false;
  specModes = ['List', 'Create'];
  specMode;
  selectedSpec;
  mappedFields: any = [];
  mappedFieldsForFile: any = [];
  unMappedFields = [];
  unMappedFieldsForFile: any = [];
  mandatoryFileds = [];
  shipperAddressData = [];
  mappingOptions = [];
  easyShipFieldData;
  standardShipdata;
  @Output() dirtyEvent = new EventEmitter<boolean>();
  isDirty = false;
  isUseFromFile = false;

  constructor(
    private fb: FormBuilder,
    private configService: ConfigService,
    private errorDialogService: ErrorDialogService,
    private addressService: AddressService,
    private snackBarService: SnackBarService
  ) {}

  public shipmentMappingForm: FormGroup;

  ngOnInit(): void {
    this.userExportedInvoice = sessionStorage.getItem('isCustomInvoice') === 'Custom';
    this.specMode = 'List';
    this.initializationformGroup();
    this.getShipperAddressData();
    this.getMappingOptions();
    this.getMappedFields('EASYSHIP');
    this.getMappedFields('STANDARD');
  }

  ngAfterViewInit() {
    this.isShipmentMappingUnChanged();
  }

  canDeactivate() {
    return this.isDirty;
  }

  isCheckedUseFromFile(event: MatCheckboxChange) {
    this.isUseFromFile = event.checked;
    if (this.isUseFromFile) {
      this.mappedFields = this.mappedFieldsForFile;
      this.unMappedFields = this.unMappedFieldsForFile;
    }
    this.shipmentMappingForm.patchValue({ use_shipper_id: '' });
  }

  isShipmentMappingUnChanged() {
    setTimeout(() => {
      setTimeout(
        function () {
          this.shipmentMappingForm.valueChanges.subscribe(() => {
            this.isDirty = true;
            this.dirtyEvent.emit(this.isDirty);
          });
        }.bind(this),
        0
      );
    }, 1000);
  }

  initializationformGroup() {
    this.shipmentMappingForm = this.fb.group({
      specifications_id: ['', Validators.required],
      file_format: ['', Validators.required],
      delimiter: ['', Validators.required],
      acceptTerms: ['True'],
      use_for_automated_upload: [false],
      use_shipper_id: '',
      headers: [false],
      useFromFile: [false],
      abortOnErrors: [false, Validators.required],
    });
  }

  easyship() {
    this.mapOptionData(this.easyShipFieldData);
  }

  standard() {
    this.mapOptionData(this.standardShipdata);
  }

  specModeChangeEvent() {
    this.selectedSpec = '';
    this.shipmentMappingForm.reset();
    this.mappedFields = this.mappedFieldsForFile = [];
    this.unMappedFields = [];
    this.unMappedFieldsForFile = [];
    this.mandatoryFileds = [];
    this.isUseFromFile = false;
    this.shipmentMappingForm.patchValue({ abortOnErrors: false });
    this.shipmentMappingForm.patchValue({ use_for_automated_upload: false });
  }

  specSelectEvent(spec) {
    this.shipmentMappingForm.reset();
    this.getSelectMappingOption(spec.value.specifications_id, spec.value.file_format);
  }

  changeAddressValue(address) {
    this.mappedFields = customMappingConfig(this.mappedFields, addressItemToRemoveInShipper);
    this.unMappedFields = customMappingConfig(this.unMappedFields, addressItemToRemoveInShipper);
    this.shipmentMappingForm.controls.use_shipper_id.setValue(address.value);
  }

  getSelectMappingOption(specId, specFormat) {
    this.shipmentMappingForm.reset();
    this.configService
      .getMappingFromOption('customer_mapping_specifications', specId)
      .subscribe(res => {
        this.isUseFromFile = !res[0]?.use_shipper_id;
        this.shipmentMappingForm.patchValue({ useFromFile: this.isUseFromFile });
        this.mappedFields = [];
        this.mappedFieldsForFile = this.mappedFields = res[0].data.map(function (item) {
          return item === 'TBA' ? 'Blank' : item;
        });

        if (this.userExportedInvoice) {
          this.mappedFieldsForFile = this.mappedFields = customMappingConfig(
            res[0].data,
            exportCustomerInvoiceItemsToRemoveInShipmentMapping
          );

          //TODO : In-case mapped issue if customer is enabled invoice
          this.unMappedFieldsForFile = this.unMappedFields = customMappingConfig(
            this.unMappedFields,
            exportCustomerInvoiceItemsToRemoveInShipmentMapping
          );
        }

        if (specFormat === 'EASYSHIP') {
          const allEasyshipFields = this.getAllShipFields(this.easyShipFieldData);
          this.unMappedFieldsForFile = this.unMappedFields = this.filterTwoArrayNotIncluded(
            allEasyshipFields,
            this.mappedFields
          );
          this.mandatoryFileds = this.getMondatoryFields(this.easyShipFieldData);

          this.assignFormFieldsData(res[0]);
        } else {
          const allStandardshipFields = this.getAllShipFields(this.standardShipdata);
          this.unMappedFieldsForFile = this.unMappedFields = this.filterTwoArrayNotIncluded(
            allStandardshipFields,
            this.mappedFields
          );
          this.mandatoryFileds = this.getMondatoryFields(this.standardShipdata);
          this.assignFormFieldsData(res[0]);
        }
      });
  }

  assignFormFieldsData(data) {
    this.shipmentMappingForm.patchValue(data);
  }

  filterTwoArrayNotIncluded(arr1, arr2) {
    const unMappedWithBlank = ['Blank'];

    const arrayUnmapped = arr1.filter(x => !arr2.includes(x));

    return unMappedWithBlank.concat(arrayUnmapped);
  }

  getAllShipFields(mappingData) {
    const shipFields = [];

    for (const mappingObj of mappingData) {
      const fieldName = mappingObj.field_name;
      shipFields.push(fieldName);
    }
    return shipFields;
  }

  getMappedFields(fileformat) {
    const id = 'field_specifications';
    this.configService.getMappingFields(id, fileformat).subscribe(response => {
      this.userExportedInvoice
        ? this.getCustomInvoiceAvailableFields(fileformat, response)
        : this.getDefaultAvailableFields(fileformat, response);
    });
  }

  getCustomInvoiceAvailableFields(fileFormat, response) {
    return fileFormat === 'EASYSHIP'
      ? (this.easyShipFieldData = customMappingObjectConfig(response[0].data))
      : (this.standardShipdata = customMappingObjectConfig(response[0].data));
  }

  getDefaultAvailableFields(fileFormat, response) {
    return fileFormat === 'EASYSHIP'
      ? (this.easyShipFieldData = response[0].data)
      : (this.standardShipdata = response[0].data);
  }

  mapOptionData(mappingData) {
    this.checkExportedInvoiceEnabled();
    this.mappedFields = [];
    this.unMappedFields = ['Blank'];
    this.mandatoryFileds = [];
    for (const mappingObj of mappingData) {
      const fieldName = mappingObj.field_name;
      if (mappingObj.required === 'M') {
        this.mappedFields.push(fieldName);
        this.mappedFieldsForFile = this.mappedFields;
        this.mandatoryFileds.push(fieldName);
      } else {
        this.unMappedFieldsForFile = this.unMappedFields;
        this.unMappedFields.push(fieldName);
      }
    }
    
  }

  checkExportedInvoiceEnabled() {
    this.userExportedInvoice = sessionStorage.getItem('isCustomInvoice') === 'Custom';
    //TODO : If the customer have export invoice enabled
    if (this.userExportedInvoice) {
      this.mappedFields = customMappingConfig(
        this.mappedFields,
        exportCustomerInvoiceItemsToRemoveInShipmentMapping
      );
      this.unMappedFields = customMappingConfig(
        this.unMappedFields,
        exportCustomerInvoiceItemsToRemoveInShipmentMapping
      );
    }
  }

  getMondatoryFields(mappingData) {
    this.mandatoryFileds = [];
    for (const mappingObj of mappingData) {
      const fieldName = mappingObj.field_name;
      if (mappingObj.required === 'M') {
        this.mandatoryFileds.push(fieldName);
      }
    }
    return this.mandatoryFileds;
  }

  drop(event: CdkDragDrop<string[]>) {
    this.isDirty = true;
    this.dirtyEvent.emit(this.isDirty);
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      if (this.isFieldMondatory(event.previousContainer.data[event.previousIndex])) {
        return;
      } else {
        const previousIndexValue = event.previousContainer.data[event.previousIndex];
        if (previousIndexValue === 'Blank' && event.previousContainer.id === 'cdk1') {
          this.mappedFields.splice(event.currentIndex, 0, previousIndexValue);
          return;
        }
        if (previousIndexValue === 'Blank' && event.previousContainer.id === 'cdk2') {
          this.mappedFields.splice(event.previousIndex, 1);
          return;
        }

        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
      }
    }
  }

  isFieldMondatory(field) {
    return this.mandatoryFileds.includes(field);
  }

  getShipperAddressData() {
    const requestData = {
      query: {
        address_type: ['SHIPPER'],
      },
    };
    this.addressService.getAddressList(requestData).subscribe(
      res => {
        for (const addressObj of res.data) {
          const AddressString = addressObj.address_id;
          this.shipperAddressData.push(AddressString);
        }
      }
      // err => {
      //   console.log('error' + err);
      // }
    );
  }

  saveShipmentConfigMapping() {
    if (!this.shipmentMappingForm.valid) {
      this.errorDialogService.openDialog('alert.enterAllMandatory', false);
      return;
    }

    if (this.shipmentMappingForm.value.use_for_automated_upload === '') {
      this.shipmentMappingForm.value.use_for_automated_upload = false;
    }

    if (this.shipmentMappingForm.value.abortOnErrors === '') {
      this.shipmentMappingForm.value.abortOnErrors = false;
    }
    const dataFields = this.mappedFields.map(function (item) {
      return item === 'Blank' ? 'TBA' : item;
    });

    const options = {
      config_id: 'customer_mapping_specifications',
      specifications_id: this.shipmentMappingForm.value.specifications_id,
      headers: Boolean(this.shipmentMappingForm.value.headers),
      data: this.userExportedInvoice
        ? customMappingConfig(dataFields, exportCustomerInvoiceItemsToRemoveInShipmentMapping)
        : dataFields,
      file_format: this.shipmentMappingForm.value.file_format,
      use_for_automated_upload: Boolean(this.shipmentMappingForm.value.use_for_automated_upload),
      delimiter: this.shipmentMappingForm.value.delimiter,
      abortOnErrors: Boolean(this.shipmentMappingForm.value.abortOnErrors),
      use_shipper_id: this.shipmentMappingForm.value.use_shipper_id,
    };

    this.configService.saveMappingOption(options).subscribe(() => {
      this.snackBarService.createSnackBar(
        basicSnackBarConfig.mappingShipmentSpecificationSave?.message,
        basicSnackBarConfig.mappingShipmentSpecificationSave?.horizontalPosition,
        basicSnackBarConfig.mappingShipmentSpecificationSave?.verticalPosition,
        basicSnackBarConfig.mappingShipmentSpecificationSave?.duration
      );
      this.getMappingOptions();
      this.specMode = 'List';
    });
  }

  getMappingOptions() {
    const id = 'customer_mapping_specifications';
    this.configService.getListOfMappings(id).subscribe(data => {
      const spec = this.selectedSpec;
      this.mappingOptions = data[0];
      this.selectedSpec = spec;
      this.isDirty = false;
      this.dirtyEvent.emit(this.isDirty);
    });
  }

  lineItemList = [
    { name: 'lineItemNumber' },
    { name: 'lineItemDiscription' },
    { name: 'lineItemUnitPrice' },
    { name: 'lineItemUnitPriceCurrency' },
    { name: 'lineItemQuantity' },
    { name: 'lineItemQuantityUnitofMeasurement' },
    { name: 'lineItemExportCommodityCode' },
    { name: 'lineItemImportCommodityCode' },
    { name: 'lineItemExportReasonType' },
    { name: 'lineItemPartNumber' },
    { name: 'lineItemReference' },
    { name: 'lineItemManufactureCountry' },
    { name: 'lineItemNetWeight' },
    { name: 'lineItemGrossWeight' },
  ];
  lineItemLists = this.lineItemList.map(list => (list.name as any).padEnd(15)).join('\n');

  piecesList = [
    { name: 'pieceNumber' },
    { name: 'piecePackagingType' },
    { name: 'piecePackagingLength' },
    { name: 'piecePackageWidth' },
    { name: 'piecePackageHeight' },
    { name: 'piecePackageWeight' },
    { name: 'pieceReference' },
    { name: 'pieceId' },
    { name: 'pieceContentDescription' },
  ];
  pieceslists = this.piecesList.map(lists => (lists.name as any).padEnd(15)).join('\n');

  editSpecEvent(spec) {
    this.specMode = 'Edit';
    const specValue = {
      specifications_id: spec.specId,
      file_format: spec.fileFormat,
      _id: spec._id,
    };
    this.specSelectEvent({ value: specValue });
    this.selectedSpec = { value: specValue };
  }
}
